/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerInfo_seller = {
    readonly agreementStart: string | null;
    readonly shippingAddress: {
        readonly displayCityStateCountry: string | null;
    } | null;
    readonly analytics: {
        readonly metrics: {
            readonly responseTime: {
                readonly value: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedDealerInfo_seller";
};
export type PdpSharedDealerInfo_seller$data = PdpSharedDealerInfo_seller;
export type PdpSharedDealerInfo_seller$key = {
    readonly " $data"?: PdpSharedDealerInfo_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerInfo_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDealerInfo_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "agreementStart",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shippingAddress",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayCityStateCountry",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "analytics",
      "storageKey": null,
      "args": null,
      "concreteType": "MCAnalytics",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "metrics",
          "storageKey": null,
          "args": null,
          "concreteType": "MCAnalyticsMetrics",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "responseTime",
              "storageKey": null,
              "args": null,
              "concreteType": "MCMetricResponseTime",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '451e12ddd92761c0ff4f2914d1c5d3fe';
export default node;
